import React, { PureComponent } from 'react';
import { size } from 'lodash-es';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router';
import { reduxForm, InjectedFormProps } from 'redux-form';

import { Pagination, Table } from '../../../core/components';
import { PanelSection, TabLink, Tabs } from '../../../core/components/styled';
import translate from '../../../core/services/translate';
import { getQueryParams } from '../../../utils/services/queryParams';
import { LIMIT_PER_PAGE } from '../../constants';
import { loadRecurringServices } from '../../ducks';
import recurringServicesInitialValueSelector from '../../services/recurringServicesInitialValueSelector';
import { RecurringServicesFormTableRow } from '.';
import { AppState } from '../../../store';

interface RouteParams {
  token: string;
}

interface ComponentProps extends RouteComponentProps<RouteParams> {
  vendorId: number;
}

interface PropsWithoutReduxForm extends ComponentProps {
  initialValues: any;
  isLoading: boolean;
  isSaving: boolean;
  pricingInfo: any;
  workOrdersInfo?: any[];
  total: number;
  loadRecurringServices(...args: any[]): any;
}

type Props = PropsWithoutReduxForm & InjectedFormProps<any, PropsWithoutReduxForm>;

class RecurringServicesForm extends PureComponent<Props> {
  componentDidUpdate(prevProps: Props) {
    const { location, vendorId, loadRecurringServices, pricingInfo } = this.props;

    if (prevProps.location.search !== location.search) {
      const { page } = getQueryParams(location.search);
      const date = moment(pricingInfo.reportDate).format('YYYY-MM-DD');
      const token = this.props.match.params.token;

      return Promise.all([loadRecurringServices(vendorId, token, date, page, LIMIT_PER_PAGE)]);
    }
  }

  handleSubmit = (event: any) => {
    event.preventDefault();
  };

  recurringServicesTableCells = [
    { name: 'Status', label: translate('common.status'), width: '8%', sortable: false },
    { name: 'Division Name', label: translate('payment.divisionName'), width: '16%', sortable: false },
    { name: 'Customer Location', label: translate('payment.customerLocation'), width: '16%', sortable: false },
    { name: 'Work Order', label: translate('payment.workOrder'), width: '12%', sortable: false },
    { name: 'Service Information', label: translate('payment.serviceInformation'), width: '16%', sortable: false },
    { name: 'Confirmed', label: translate('payment.confirmed'), width: '12%', sortable: false },
    { name: 'Action', label: translate('payment.action'), width: '20%', sortable: false },
  ];

  render() {
    const { workOrdersInfo, match, total } = this.props;

    return (
      <form onSubmit={this.handleSubmit} noValidate>
        <PanelSection centered withBorder padding="sMedium">
          <Tabs>
            <TabLink to={`/payments/recurring-service/${match.params.token}`}>
              {translate('payment.recurringService')}
            </TabLink>
            <TabLink to={`/payments/oncall-service/${match.params.token}`}>
              {translate('payment.oncallService')}
            </TabLink>
            <TabLink to={`/payments/processed-service/${match.params.token}`}>
              {translate('payment.processedService')}
            </TabLink>
          </Tabs>
        </PanelSection>

        <PanelSection>
          {!!size(workOrdersInfo) && (
            <Table
              cells={this.recurringServicesTableCells}
              rows={workOrdersInfo}
              rowComponent={RecurringServicesFormTableRow}
            />
          )}
        </PanelSection>
        <Pagination totalResults={total!} />
      </form>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  initialValues: recurringServicesInitialValueSelector(state.payments.recurringServices.workOrdersInfo),
  isLoading: state.payments.recurringServices.isLoading,
  isSaving: state.payments.recurringServices.isSaving,
  pricingInfo: state.payments.recurringServices.pricingInfo,
  total: state.payments.recurringServices.total as any as number,
  workOrdersInfo: state.payments.recurringServices.workOrdersInfo,
});

const mapDispatchToProps = {
  loadRecurringServices,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(
    reduxForm<any, PropsWithoutReduxForm>({
      form: 'recurringServicesForm',
      enableReinitialize: true,
    })(RecurringServicesForm),
  ),
);
